import script from "./DataTables.vue?vue&type=script&setup=true&lang=js"
export * from "./DataTables.vue?vue&type=script&setup=true&lang=js"

import "./DataTables.vue?vue&type=style&index=0&id=9803d282&lang=css"

const __exports__ = script;

export default __exports__